export const GQL_PATH = '/api/graphql'
